import * as React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Typography, styled, TypographyProps } from '@mui/material';
import rehypeRaw from 'rehype-raw';

type Props = {
  markdown?: string;
  color?: TypographyProps['color'];
};

const RichTextContainer = styled('div')(({ theme }) => ({
  '& h1': {
    ...theme.typography.h1,
    marginBottom: theme.spacing(2),
  },
  '& h2': {
    ...theme.typography.h2,
    marginBottom: theme.spacing(2),
  },
  '& h3': {
    ...theme.typography.h3,
    marginBottom: theme.spacing(2),
  },
  '& h4': {
    ...theme.typography.h4,
    marginBottom: theme.spacing(2),
  },
  '& h5': {
    ...theme.typography.h5,
    marginBottom: theme.spacing(2),
  },
  '& h6': {
    ...theme.typography.h6,
    marginBottom: theme.spacing(2),
  },
  '& p': {
    ...theme.typography['body-500'],
    marginBottom: theme.spacing(2),
  },
  '& ul': {
    paddingLeft: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  '& li': {
    ...theme.typography.body1,
    marginBottom: theme.spacing(1),
  },
  '& ol': {
    listStyleType: 'decimal',
    paddingLeft: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  '& blockquote': {
    borderLeft: `4px solid ${theme.palette.grey[400]}`,
    margin: theme.spacing(2, 0),
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.grey[100],
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
  },
}));

const MarkdownRenderer: React.FC<Props> = ({ markdown, color = 'textSecondary' }) => {
  if (!markdown) return null;

  return (
    <RichTextContainer>
      <Typography component="div" color={color}>
        <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
          {markdown}
        </Markdown>
      </Typography>
    </RichTextContainer>
  );
};

export { MarkdownRenderer };
